export default __webpack_public_path__ + "static/media/speach.22ef0ef9.jpeg";